export const customers = {
    intesa: {
        formCode: "intesa",
        formTitle: "Intesa - Supporto Clienti",
        formBackground: "intesa-bg.jpg"
    }
};
